import { render, staticRenderFns } from "./ImpersonateLink.vue?vue&type=template&id=07f85da7"
import script from "./ImpersonateLink.vue?vue&type=script&lang=js"
export * from "./ImpersonateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports